import { App } from "antd";
import { useMutation } from "@tanstack/react-query";
import api from "../../utils/api";

interface UploadAcceptanceFormPayload {
  scholarship: File;
}

const uploadAcceptanceForm = async (payload: FormData) => {
  return (
    await api.post("/scholarship/upload-acceptance", payload, {
      headers: { "Content-Type": "multipart/form-data" },
    })
  ).data as Response;
};

export const useUploadAcceptanceFormMutation = () => {
  const { notification } = App.useApp();

  const mutation = useMutation({
    mutationFn: uploadAcceptanceForm,
  });

  const uploadAcceptanceFormHandler = async ({
    scholarship,
  }: UploadAcceptanceFormPayload) => {
    const formData = new FormData();
    formData.append("scholarship", scholarship);

    try {
      const response = await mutation.mutateAsync(formData);

      notification.success({
        message: "Success",
        description: response?.message || "Acceptance form uploaded successfully",
      });

      return response;
    } catch (error: any) {
      notification.error({
        message: "Error",
        description:
          error?.response?.data?.message || "Failed to upload acceptance form",
      });
      throw error;
    }
  };

  return {
    ...mutation,
    uploadAcceptanceForm: uploadAcceptanceFormHandler,
    isLoading: mutation.isPending,
  };
};

export default useUploadAcceptanceFormMutation;
